import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Global from './global.js'
import Tyc from './tyc.js'
import Rqs from './rqs.js'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import req from './api/req.js'
import 'element-ui/lib/theme-chalk/index.css'
require('./gcss.css') // eslint-disable-line

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Global)
Vue.use(Tyc)
Vue.use(Rqs)
Vue.use(VueI18n)
req.common.changeLang()
Vue.prototype.req = req
router.beforeEach((to, from, next) => {
  ////// set route name
  // store.commit('SET_RTNAME',to.name)
  next()  
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')